export * from '@primeuix/themes/aura/splitter';
export { default } from '@primeuix/themes/aura/splitter';
